import { render, staticRenderFns } from "./ExemptionStatusBadge.vue?vue&type=template&id=12ce449f&"
import script from "./ExemptionStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ExemptionStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./ExemptionStatusBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports